<script setup>
import { defineProps, computed, reactive, ref, watch } from 'vue';
import VueApexCharts from "vue3-apexcharts";

const chartLabelColor = '#fff';
const chartBarColor = '#4CAF50';
const chartExpectedAmountColor = '#775DD0';

const props = defineProps({
    data: {
        type: Array,
        required: true,
    },
    chartTitle: {
        type: String,
        default: null,
    },
    xAxisTitle: {
        type: String,
        default: null,
    },
    yAxisTitle: {
        type: String,
        default: null,
    },
    expectedAmountSoFar: {
        type: Number,
        default: 0,
    },
    totalDaysSoFar: {
        type: Number,
        default: 0,
    },
    targetAmount: {
        type: Number,
        default: 0,
    }
});


const showAnnotations = ref(false);

let chartOptions = ref({
    chart: {
        type: "area",
        foreColor: '#898989',
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false
        },
    },
    colors: [chartBarColor],
    stroke: {
        width: 2,
        curve: 'smooth',
    },
    plotOptions: {
        // bar: {
        //     dataLabels: {
        //         position: 'top'
        //     }
        // }
    },
    dataLabels: {
        enabled: false,
    },
    title: {
        text: props.chartTitle || '',
        align: 'center',
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: chartLabelColor
        },
    },
    grid: {
        enabled: false,
        yaxis: {
            lines: {
                show: false
            }
        },
        xaxis: {
            lines: {
                show: false
            }
        }
    },
    xaxis: {
        axisBorder: {
            color: chartLabelColor,
        },
        title: {
            text: props.xAxisTitle || '',
            style: {
                color: chartLabelColor
            }
        },
        labels: {
            show: false
        }
    },
    yaxis: {
        min: 0,
        max: 12000,
        axisBorder: {
            color: chartLabelColor,
        },
        title: {
            text: props.yAxisTitle || '',
            style: {
                color: chartLabelColor,
            },
        },
        tooltip: {
            enabled: true,
        },
    },
    menu: {
        enabled: false
    },
    fill: {
        opacity: .6,
        type: 'gradient',
    },
    tooltip: {
        enabled: false,
    },
    markers: {
        size: 0,
        strokeColor: chartLabelColor,
        hover: {
            size: 9
        }
    },
    annotations: {
        yaxis: [
            {
                y: props.targetAmount,
                borderColor: chartLabelColor,
                strokeDashArray: 2,
                label: {
                    borderColor: chartLabelColor,
                    borderWidth: 0,
                    borderRadius: 2,
                    offsetY: 7,
                    offsetX: -5,
                    style: {
                        color: '#000',
                        background: chartLabelColor,
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 4,
                        }
                    },
                    text: '🏁 Goal',
                }
            },
            {
                y: props.targetAmount / 2,
                borderColor: chartLabelColor,
                strokeDashArray: 2,
                label: {
                    borderColor: chartLabelColor,
                    borderWidth: 0,
                    borderRadius: 2,
                    offsetY: 7,
                    offsetX: -5,
                    style: {
                        color: '#000',
                        background: chartLabelColor,
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 4,
                        }
                    },
                    text: '🏅 Halfway',
                }
            },
            {
                y: 0,
                y2: props.expectedAmountSoFar,
                borderColor: chartExpectedAmountColor,
                opacity: 0.15,
                fillColor: chartExpectedAmountColor,
                strokeDashArray: 1,
                label: {
                    borderColor: chartExpectedAmountColor,
                    borderWidth: 0,
                    borderRadius: 2,
                    offsetY: 7,
                    offsetX: -5,
                    style: {
                        color: '#fff',
                        background: chartExpectedAmountColor,
                        padding: {
                            left: 5,
                            right: 5,
                            top: 2,
                            bottom: 4,
                        }
                    },
                    text: 'Expected amount',
                }
            }
        ]
    }
});

const dataParsed = computed(() => {
    return props.data.map((item) => {
        return {
            x: item['date'],
            y: item['runningTotal']
        }
    });
});

const series = reactive([
    {
        color: chartBarColor,
        zIndex: 1,
        data: dataParsed || []
    }
])


watch(() => props.data, (newValue) => {
    series[0].data = dataParsed;
});
</script>

<template>
    <div class="repsOverTimeChart">
        <VueApexCharts type="area" :options="chartOptions" :series="series" height="450" />
    </div>
</template>